export { default } from './MonoText';
